export interface SlideData {
  imageSrc: string;
  imageAlt: string;
  title: string;
  description: string;
  linkText: string;
  linkHref: string;
}

export const FEATURES_CAROUSEL_SLIDES: SlideData[] = [
  {
    imageSrc: 'https://safariportal-media-production.s3.us-east-1.amazonaws.com/Image3.png',
    imageAlt: 'Invoice',
    title: 'Create & Send Invoices Instantly',
    description:
      'Build invoices and collect client payments right inside Safari Portal, including for planning fees or trip costs. Manage supplier payments and track profitability with ease.',
    linkText: 'How to Create Invoices',
    linkHref: 'https://help.safariportal.app/en/articles/6063-invoicing-financials',
  },
  {
    imageSrc: 'https://safariportal-media-production.s3.us-east-1.amazonaws.com/Image4.png',
    imageAlt: 'Built in AI',
    title: 'Save Hours with Built-In AI',
    description:
      'Generate polished content pages in seconds with AI, or choose from thousands of prebuilt pages from the Safari Portal Content Library.',
    linkText: 'How do I use AI?',
    linkHref: 'https://help.safariportal.app/en/articles/5576-how-do-i-use-safari-portals-ai',
  },
  {
    imageSrc: 'https://safariportal-media-production.s3.us-east-1.amazonaws.com/Image5.png',
    imageAlt: 'Contacts',
    title: 'Collect, Manage, and Share Client Information',
    description:
      'Collect details from travelers, sync them directly to their profiles, and share with partners with one click.',
    linkText: 'Learn More',
    linkHref: 'https://help.safariportal.app/en/articles/6062--contact-management',
  },
];
